import { render, staticRenderFns } from "./DeletionPractise.vue?vue&type=template&id=5172de5a&"
import script from "./DeletionPractise.vue?vue&type=script&lang=js&"
export * from "./DeletionPractise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports